import useUserEmails from './useUserEmails';

export default function usePrimaryEmail() {
  const { data: emails } = useUserEmails();
  return emails.find(({ isPrimary }) => isPrimary)?.email;
}
